import React, {useContext, useEffect, useRef, useState} from "react";
import {useHistory, useParams} from 'react-router-dom';
import * as Yup from "yup";
import {TranslateContext} from "../../context/TranslateContext";
import {
    getClasseMacrocategoriaByIdApi,
    aggiornaClasseMacrocategoriaApi,
    aggiungiClasseMacrocategoriaApi
} from "./services/MacrocategorieServices";
import ModificaClasseMacrocategoriaView from "./ModificaClasseMacrocategoriaView";

export default function ModificaClasseMacrocategoriaController() {
    const {id} = useParams()

    const iconaDefault = 'fas fa-building';

    const [loadingData, setLoadingData] = useState(true);
    const [show, setShow] = useState(false);
    const [modalMsg, setModalMsg] = useState(false);

    const {translate} = useContext(TranslateContext);

    const history = useHistory();
    const formikRef = useRef();

    async function getClassiKpi() {
        const response = await getClasseMacrocategoriaByIdApi(id);
        setLoadingData(false);

        if (formikRef.current) {
            formikRef.current.setFieldValue("id_classe_macrocategoria", response.data.data.id_classe_macrocategoria)
            formikRef.current.setFieldValue("codice", response.data.data.codice)
            formikRef.current.setFieldValue("descrizione", response.data.data.descrizione)
            formikRef.current.setFieldValue("canc", response.data.data.canc)
            formikRef.current.setFieldValue("icona", response.data.data.icona)
        }
    }

    useEffect(() => {
        if (loadingData) {
            if (id && id !== '') {
                getClassiKpi();
            }
        }
    }, []);

    const SignupSchema = Yup.object().shape({
        codice: Yup.string()
            .max(20, translate('Valore troppo lungo'))
            .required(translate('Questo campo è obbligatorio')),
        descrizione: Yup.string()
            .max(200, translate('Valore troppo lungo'))
            .required(translate('Questo campo è obbligatorio')),
    });

    async function aggiornaClasseMacrocategoria(values) {
        const response = await aggiornaClasseMacrocategoriaApi(id, values);
        if (response.data.result === 0) {
            history.goBack();
        } else {
            setModalMsg(response.data.description);
            setShow(true);
        }
    }

    async function aggiungiClasseMacrocategoria(values) {
        const response = await aggiungiClasseMacrocategoriaApi(values);
        if (response.data.result === 0) {
            history.goBack();
        } else {
            setModalMsg(response.data.description);
            setShow(true);
        }
    }

    const bottoniSx = [
        {
            icon: 'fas fa-angle-left',
            command: () => {
                history.goBack();
            }
        }
    ];

    const bottoniDx = [
        {
            label: translate("Salva"),
            icon: "fas fa-save",
            command: () => {
                if (formikRef.current) {
                    formikRef.current.handleSubmit()
                }
            }
        }
    ];

    const initialValuesForm = {
        id_classe_macrocategoria: '',
        codice: '',
        descrizione: '',
        canc: '',
        icona: iconaDefault
    };

    function onSubmitForm(values) {
        if (id) {
            aggiornaClasseMacrocategoria(values);
        } else {
            aggiungiClasseMacrocategoria(values);
        }
    }

    return (
        <ModificaClasseMacrocategoriaView
            show={show}
            setShow={setShow}
            id={id}
            formikRef={formikRef}
            modalMsg={modalMsg}
            SignupSchema={SignupSchema}
            iconaDefault={iconaDefault}
            bottoniSx={bottoniSx}
            bottoniDx={bottoniDx}
            initialValuesForm={initialValuesForm}
            onSubmitForm={onSubmitForm}
        />
    );
}